var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-wrap"},[_c('HomeHeader'),_c('QuestionPopup'),_c('CarouselList'),_c('HomeInfo'),_c('HomeNews'),_c('VFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }